import { Menu } from "lucide-react";
import Link from "next/link";

import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { WinShopLogo } from "@winshop-crm/ui";

const navigation = [
  // { name: "Informace", href: "/info" },
  { name: "Kontakty", href: "https://www.pokladny.com/kontakty.html" },
];

const Navbar = () => {
  return (
    <header className="sticky top-0 z-50 w-full bg-neutral-background">
      <nav
        className="flex items-center justify-between px-4 py-6 mx-auto max-w-7xl sm:px-6 lg:px-8"
        aria-label="Global"
      >
        <Link href="/" passHref>
          <WinShopLogo />
        </Link>

        <div className="hidden md:flex md:space-x-8">
          {navigation.map((item) => (
            <Link key={item.name} href={item.href} className="font-medium text-neutral-text">
              {item.name}
            </Link>
          ))}
          <Link href="/auth/signIn" className="font-medium text-primary-text">
            Přihlásit se
          </Link>
        </div>

        <div className="-mr-2 md:hidden">
          <Sheet>
            <SheetTrigger className="inline-flex items-center justify-center p-2 rounded-md bg-neutral-background text-primary-action hover:text-primary-actionHover hover:bg-neutral-backgroundSubtle focus:outline-hidden">
              <span className="sr-only">Otevřít menu</span>
              <Menu className="w-6 h-6" aria-hidden="true" />
            </SheetTrigger>
            <SheetContent side="right">
              <SheetHeader>
                <SheetTitle className="sr-only">Menu</SheetTitle>
                <WinShopLogo className="w-auto h-8" />
              </SheetHeader>
              <div className="px-2 pt-2 pb-3 space-y-1">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    href={item.href}
                    className="block px-3 py-2 text-base font-medium rounded-md text-neutral-text hover:bg-neutral-actionSecondaryHover"
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
              <Link
                href="/auth/signIn"
                className="block w-full px-5 py-3 font-medium text-center text-primary-text bg-neutral-actionSecondary hover:bg-neutral-actionSecondaryHover"
              >
                Přihlásit se
              </Link>
            </SheetContent>
          </Sheet>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
